import { render } from "./Message.vue?vue&type=template&id=e3943f3c&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=e3943f3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3943f3c"]])

export default __exports__